import Package from "@/components/colis/Colis";
import CanceledReturnConfirmationDialog from "@/components/dialogs/CanceledReturnConfirmationDialog";
import ActionButton from "@/components/loader-button/ActionButton";
import { NavigationRoutes } from "@/components/navigation/constants";
import ReturnHeader from "@/components/return/ReturnHeader";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Toaster } from "@/components/ui/toaster";
import { ReturnStatus, Roles } from "@/enums";
import { RootState } from "@/store/store";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CanceledReturnPermanentPage: React.FC = () => {
  const navigate = useNavigate();
  const [isOpened, setIsOpened] = useState(false);
  const roles = useSelector((state: RootState) => state.authentication.roles);
  const return_ = useSelector((state: RootState) => state.return.return);

  const isReceivedPermanentlyForWarehouse =
    return_.statutId === ReturnStatus.recu_provisoire &&
    roles.includes(Roles.WAREHOUSE_ROLE);

  useEffect(() => {
    if (
      return_.numTournee === null ||
      return_.numTournee === undefined ||
      !isReceivedPermanentlyForWarehouse
    ) {
      navigate(NavigationRoutes.DASHBOARD);
    }
  }, []);

  return (
    <>
      <ReturnHeader return_={return_} />
      <ScrollArea className="flex-1 flex-grow" showScrollIndicator>
        {return_.colis &&
          return_.colis.map((colis, index) => (
            <Package key={index} colis={colis} />
          ))}
      </ScrollArea>
      {isReceivedPermanentlyForWarehouse && (
        <>
          <div className="px-4">
            <ActionButton
              label="Confirmer"
              disabled={!return_.colis || return_.colis.length === 0}
              handleClick={() => setIsOpened(true)}
              loading={false}
            />
          </div>
          <CanceledReturnConfirmationDialog
            isOpened={isOpened}
            setIsOpened={setIsOpened}
            validColis={return_.colis ?? []}
            returnNumber={
              return_.numTournee ? return_.numTournee.toString() : ""
            }
          />
        </>
      )}
      <Toaster />
    </>
  );
};

export default CanceledReturnPermanentPage;
